import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-close-01',
	templateUrl: './icon-close-01.component.svg',
})
export class IconClose01Component {}
